import { CustomTooltip } from "@shared/components/CustomTooltip";
import { useCurrency } from "@shared/selectors/globalSelectors";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Activity } from "lucide-react";
import React from "react";

interface KeyStatsCardProps {
  data: {
    lastPaidAmount: number;
    lastPaidOn: number;
    remaining: number;
  };
}

export const KeyStatsCard: React.FC<KeyStatsCardProps> = ({ data }) => {
  const currency = useCurrency();
  return (
    <Card>
      <CardHeader className="">
        <div className="flex items-center gap-2">
          <CardTitle className="text-lg font-semibold">Payment Status</CardTitle>
        </div>
      </CardHeader>
      <CardContent className="space-y-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-600">Last Paid Amount</span>
            {/* <CustomTooltip message="Total meters included in this cycle scope." /> */}
          </div>
          <span>{currency} {data?.lastPaidAmount ?? "NA"}</span>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-600">Last Paid On</span>
            {/* <CustomTooltip message="Number of readings submitted so far in this cycle." /> */}
          </div>
          <div className="text-right">
            <span>
              {data?.lastPaidOn ?? "NA"}
            </span>
          </div>
        </div>

        <div className="flex items-center justify-between border-t pt-1">
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-600">Remaining Payable</span>
            {/* <CustomTooltip message="Routes assigned to readers vs total routes in this cycle." /> */}
          </div>
          <span className="">
            {currency} {data?.remaining ?? 0}
          </span>
        </div>
      </CardContent>
    </Card>
  );
};
